import React, { createContext, useContext, useState, ReactNode } from 'react';

interface RetroactiveCargoModeContextType {
    isRetroactiveCargoModeEnabled: boolean;
    setIsRetroactiveCargoModeEnabled: (enabled: boolean) => void;
    toggleRetroactiveCargoMode: () => void;
}

const RetroactiveCargoModeContext = createContext<RetroactiveCargoModeContextType | undefined>(undefined);

export const useRetroactiveCargoMode = (): RetroactiveCargoModeContextType => {
    const context = useContext(RetroactiveCargoModeContext);
    if (!context) {
        throw new Error('useRetroactiveCargoMode must be used within a RetroactiveCargoModeProvider');
    }
    return context;
};

interface RetroactiveCargoModeProviderProps {
    children: ReactNode;
}

export const RetroactiveCargoModeProvider: React.FC<RetroactiveCargoModeProviderProps> = ({ children }) => {
    const [isRetroactiveCargoModeEnabled, setIsRetroactiveCargoModeEnabled] = useState<boolean>(false);

    const toggleRetroactiveCargoMode = () => {
        setIsRetroactiveCargoModeEnabled((prev) => !prev);
    };

    return (
        <RetroactiveCargoModeContext.Provider
            value={{
                isRetroactiveCargoModeEnabled,
                setIsRetroactiveCargoModeEnabled,
                toggleRetroactiveCargoMode,
            }}
        >
            {children}
        </RetroactiveCargoModeContext.Provider>
    );
};
